import getLang from 'I18n/utils/getLang';
import merge from 'hs-lodash/merge';
import Raven from 'raven-js';
import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useWindowDimensionsContext } from '../../hooks/useWindowDimensionsContext';
import { GRID_BREAKPOINT_MEDIUM_INT } from '../../layout/constants';
import { getFullPublicUrl, getPublicLocalizedPathname } from '../../utils/urls';
import { MARKETING_NAV_FOOTER_ID, MARKETING_NAV_HEADER_ID } from './MarketingNav.constants';
import { useMarketingNavCdnScript, useMarketingNavLanguagesContent } from './MarketingNav.hooks';
import { getWindowLocation } from './MarketingNav.utils';
import { MarketingNavGlobalStyle } from './MarketingNavGlobalStyle';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LegacyMarketingNav({
  _useMarketingNavCdnQa = false,
  children,
  location,
  loginUrl,
  navCtaText,
  navCtaUrl
}) {
  const theme = useTheme();
  const [marketingNavReady, setMarketingNavReady] = useState(false);
  const {
    requestState: marketingNavCdnRequestState
  } = useMarketingNavCdnScript({
    _useMarketingNavCdnQa
  });
  const languagesContent = useMarketingNavLanguagesContent({
    location: location || getWindowLocation()
  });
  const marketingNavCdnLoaded = marketingNavCdnRequestState === 'SUCCEEDED' && window.marketingNav != null;
  const marketingNavCdnFailed = marketingNavCdnRequestState === 'FAILED';
  const lang = getLang();
  const getHeaderContentBlob = useCallback(() => {
    let defaultHeaderContentBlob = {};
    if (marketingNavCdnLoaded) {
      try {
        defaultHeaderContentBlob = window.marketingNav.getNavContentBlob({
          type: 'header',
          locale: lang
        });
      } catch (error) {
        Raven.captureException(error);
        defaultHeaderContentBlob = {};
      }
    }
    return merge({}, defaultHeaderContentBlob, {
      upperNavContent: {
        homeUrl: `${getFullPublicUrl()}${getPublicLocalizedPathname(lang)}`,
        loginUrl,
        regionalDropdownContent: {
          languagesContent
        }
      },
      mobileNavContent: {
        languagesContent
      },
      navCta: {
        navCtaText,
        navCtaUrl
      }
    });
  }, [lang, languagesContent, loginUrl, marketingNavCdnLoaded, navCtaText, navCtaUrl]);
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  const computedHeaderVariation = windowWidth < GRID_BREAKPOINT_MEDIUM_INT ? 'default' : 'marketplace';
  useEffect(() => {
    if (marketingNavCdnLoaded) {
      try {
        window.marketingNav.renderNav({
          type: 'header',
          locale: lang,
          targetId: MARKETING_NAV_HEADER_ID,
          isLoggedIn: false,
          enableConvertFlag: true,
          variation: computedHeaderVariation,
          contentBlob: getHeaderContentBlob()
        });
        window.marketingNav.renderNav({
          type: 'footer',
          locale: lang,
          targetId: MARKETING_NAV_FOOTER_ID
        });
      } catch (error) {
        Raven.captureException(error);
      }
      setMarketingNavReady(true);
    }
  }, [computedHeaderVariation, getHeaderContentBlob, lang, marketingNavCdnLoaded]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MarketingNavGlobalStyle, {
      theme: theme
    }), /*#__PURE__*/_jsx("header", {
      id: MARKETING_NAV_HEADER_ID
    }), (marketingNavReady || marketingNavCdnFailed) && children, /*#__PURE__*/_jsx("footer", {
      id: MARKETING_NAV_FOOTER_ID
    })]
  });
}